<router-outlet> </router-outlet>

<!-- Change Password Drawer -->
<app-change-password-drawer
  [isOpen]="isChangePasswordDrawerOpen"
  (drawerClosed)="onChangePasswordDrawerClosed()"
>
</app-change-password-drawer>

<!-- Import Data Panel -->
<app-import-data-panel></app-import-data-panel>
